'use client';

import * as DS from '@aurorasolar/ds';

import { ProjectionScenario } from '../data/rateProjections';

type Props = {
  onScenarioChange: (scenario: ProjectionScenario) => void;
  scenario: ProjectionScenario;
};

// Blend leads as the default; the rest read low → high
const SCENARIOS: ProjectionScenario[] = ['BLEND', 'AEO', 'RECENT'];

// Short control labels so the segments fit a 375px viewport without the
// SegmentedControl's drag-scroll overflow (it never wraps). Full names live in
// the ledger rows and methodology.
const CONTROL_LABELS: Record<ProjectionScenario, string> = {
  AEO: 'EIA',
  BLEND: 'Blended',
  RECENT: 'Recent',
};

const LABEL_ID = 'bill-projection-scenario-label';

// Chart furniture, not a form: the stock-chart range-selector convention —
// an overline label + control, sitting between the bars and the legend
export const ScenarioSelector = ({ onScenarioChange, scenario }: Props) => {
  const segments = SCENARIOS.map((key) => ({ key, label: CONTROL_LABELS[key] }));

  return (
    <DS.Flex
      alignItems="center"
      flexDirection={{ _: 'column', md: 'row' }}
      gap={{ _: 1, md: 3 }}
      maxW="100%"
      mx="auto"
      w="fit-content"
    >
      <DS.Text color="uiHelperCopy" id={LABEL_ID} letterSpacing="0.06em" text="body12" textTransform="uppercase">
        Forecast type
      </DS.Text>
      <DS.SegmentedControl
        handleSegmentsSelected={(selectedSegments) => {
          const selected = selectedSegments[0]?.key;
          if (selected) {
            onScenarioChange(selected);
          }
        }}
        segmentGroupProps={{ 'aria-labelledby': LABEL_ID, id: 'bill-projection-scenario', role: 'group' }}
        segments={segments}
        selectedSegmentKeys={[scenario]}
        size="sm"
      />
    </DS.Flex>
  );
};
